import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e09c1a3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-item" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "export-csv" }
const _hoisted_5 = { class: "table-container" }

import { computed, ref, watch } from "vue";
import "@vuepic/vue-datepicker/dist/main.css";
import Popup from "./Popup.vue";
import TableAgnosticModel from "./TableAgnosticModel.vue";
import ExportCsvModelAgnostic from "./ExportCsvModelAgnostic.vue";
import { MonetaryValueWithCommas } from "@/services/helpers/Helper";


export default /*#__PURE__*/_defineComponent({
  __name: 'VcfsTrialBalancePopUp',
  props: {
    modelValue: { type: Boolean },
    tableRows: {},
    journalReference: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const columnNames = ref<(string & keyof any)[]>([]);
const labels = ref<string[]>([]);
const props = __props;
const tableObject = computed( () => {
    if (Array.isArray(props.tableRows) && props.tableRows.length > 0 && typeof props.tableRows[0] === 'object' && props.tableRows[0] !== null) {
        columnNames.value = Object.keys(props.tableRows[0]) as (string & keyof any)[];
        labels.value = columnNames.value.map(name => pascalCaseToWords(name));
    }
    return props.tableRows;
});
const PopUpOpen = computed<boolean>({
    get() {
        return props.modelValue ?? false; 
    },
    set(val: boolean) {
        emits('update:modelValue', val);
    }
});
const emits = __emit;

function pascalCaseToWords(str) {
  return str
    .replace(/([A-Z])/g, ' $1')
    .trim();
}
function closeChild() {
  PopUpOpen.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    modelValue: PopUpOpen.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((PopUpOpen).value = $event)),
      closeChild
    ],
    title: props.journalReference,
    hasClose: ""
  }, {
    contents: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(ExportCsvModelAgnostic, {
                dataToDownload: tableObject.value!,
                fileName: 'VCFS_Trial_Balance_Journal_Reference_Contents' + '_' + props.journalReference
              }, null, 8, ["dataToDownload", "fileName"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(TableAgnosticModel, {
                Rows: tableObject.value,
                Cols: columnNames.value,
                Labels: labels.value
              }, {
                AmountTotal: _withCtx(({ value }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.AmountTotal)), 1)
                ]),
                AmountExVat: _withCtx(({ value }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.AmountExVat)), 1)
                ]),
                AmountVat: _withCtx(({ value }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.AmountVat)), 1)
                ]),
                Amount: _withCtx(({ value }) => [
                  _createElementVNode("div", null, _toDisplayString(_unref(MonetaryValueWithCommas)(value.Amount)), 1)
                ]),
                _: 1
              }, 8, ["Rows", "Cols", "Labels"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})